import React, { useEffect, useMemo, useState } from 'react';
import { Button, Modal } from 'reactstrap'; // Make sure you have 'reactstrap' installed
import { useFormik } from 'formik';
import TableContainer from 'components/Common/DataTableContainer'; // Assuming TableContainer is a custom component
import axiosInstance from 'pages/Utility/axiosInstance';
import Breadcrumb from 'components/Common/Breadcrumb2';

import { FaEye } from "react-icons/fa";

const CustomerFeedBack = () => {
    const [isOpen, setIsOpen] = useState(false); // For modal visibility
    const [viewData, setViewData] = useState(null); // For storing feedback data to display in modal
    const [feedbacks, setFeedBacks] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchFeedbacksRequest = async () => {
        try {
            setLoading(true)
            const response = await axiosInstance.get('', { params: { sp: "usp_GetCustomerSatisfactionForms" } });
            if (response) {
                setFeedBacks(response?.data);
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
            console.log(error)
        }
    }

    useEffect(() => {
        if (loading) return;
        fetchFeedbacksRequest();
    }, [])

    // Define your columns for the data table
    const columns = useMemo(
        () => [
            {
                header: 'Work Order Number',
                accessorKey: 'workOrderNumber', // Assuming `workOrderNumber` is the field in the response
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: 'Rating',
                accessorKey: 'rating', // Assuming `comments` is the field in the response
                enableColumnFilter: false,
                enableSorting: true,
                cell: ({ row }) => {
                    return (
                        <span>{row.original?.rating}⭐</span>
                    )
                }
            },
            {
                header: 'Comment',
                accessorKey: 'comment', // Assuming `comments` is the field in the response
                enableColumnFilter: false,
                enableSorting: true,
                cell: ({ row }) => {
                    return (
                        <span style={{
                            width: '300px',
                            display: 'inline-block',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                        }}>{row.original?.comment}</span>
                    )
                }
            },
            {
                header: 'Actions',
                id: 'actions', // Unique id for this column
                cell: ({ row }) => {
                    const handleView = () => {
                        const rowData = row.original;
                        setViewData(rowData); // Set the row data to be viewed in the modal
                        setIsOpen(true); // Open the modal
                    };

                    return (
                        <div className="d-flex gap-2">
                            <Button color="info" onClick={handleView} title="View">
                                <FaEye size={18} />
                            </Button>
                        </div>
                    );
                },
            },
        ],
        []
    );

    // Formik setup for handling feedback form (if required)
    const formik = useFormik({
        initialValues: {
            name: viewData?.departmentName || '', // This may need to be adjusted if you are not passing department name
        },
        onSubmit: (values) => {
            console.log(values); // Handle the form submission here (e.g., API call)
            setIsOpen(false); // Close the modal after submission
        },
    });



    return (
        <div className="page-content">
            <div className='d-flex justify-content-between align-items-center mx-2'>
                <Breadcrumb title="Feedbacks" breadcrumbItems={[{ title: "Dashboard", link: `/dashboard` }, { title: "Feedbacks", link: '#' }]} />
            </div>
            {/* Conditionally render the table if there is feedback data */}

            <TableContainer
                loading={loading}
                columns={columns}
                data={feedbacks?.Data || []}
                isGlobalFilter={true}
                isPagination={true}
                SearchPlaceholder="Search..."
                pagination="pagination"
                docName='Customer Feedbacks'
                paginationWrapper="dataTables_paginate paging_simple_numbers"
                tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline mt-3"
            />

            {/* Modal for viewing feedback */}
            <Modal
                isOpen={isOpen}
                toggle={() => setIsOpen(!isOpen)}
                centered
                size="md"
                className="custom-modal-header p-0"
                maskClosable={false}
            >
                <form onSubmit={formik.handleSubmit}>
                    <div className="modal-body px-4 py-3">
                        <h4 className="text-center fw-bold mb-4"> Feedback</h4>

                        <div className="mb-3">
                            <label className="form-label fw-semibold fs-6 text-dark">Rating</label>
                            <div className="py-2 px-3 border rounded text-dark fs-5">
                                {viewData?.rating} ⭐
                            </div>
                        </div>

                        <div className="mb-3">
                            <label className="form-label fw-semibold fs-6 text-dark">Comment</label>
                            <div className="p-3 border rounded text-dark">
                                {viewData?.comment}
                            </div>
                        </div>
                    </div>

                    <div className="modal-footer mt-3">
                        <button type="button" className="btn btn-light" onClick={() => setIsOpen(false)}>
                            Close
                        </button>
                    </div>
                </form>
            </Modal>
        </div>
    );
};

export default CustomerFeedBack;
